import { BaseClient } from '@/common/services/api/BaseClient'
import { getQueryUrlFromData } from '@/common/utils/transformFilters'

export class StatsApi extends BaseClient {
  getRefferalsStats = this.createRequest({
    url: `/api/user/reflinks/stats`,
    method: 'get',
  })
  addToBlackList = this.createRequest({
    url: `/api/advertisements/blacklist`,
    method: 'post',
  })
  createFavoritesGroup = this.createRequest({
    url: '/api/advertisements/favourite-groups',
    method: 'post',
  })
  moveFavoritesGroups = this.createRequest({
    url: '/api/advertisements/move-favourites',
    method: 'put',
  })
  copyFavorites = this.createRequest({
    url: '/api/advertisements/favourite',
    method: 'put',
  })
  saveQueries = this.createRequest({
    url: '/api/advertisements/saved-queries',
    method: 'post',
  })
  getSavedQueriesList = this.createRequest({
    url: `/api/advertisements/saved-queries`,
    method: 'get',
  })

  addToFavorite = (data) => {
    return this.createRequest({
      url: '/api/advertisements/favourite',
      method: 'post',
      data,
    })()
  }

  getStats = (token, params) => {
    return this.createRequest({
      url: `/api/stats`,
      method: 'get',
      token,
      params,
    })()
  }

  getSavedQueries = (token) => {
    return this.createRequest({
      url: '/api/advertisements/saved-queries',
      method: 'get',
      token,
    })()
  }

  getLastQueries = (token) => {
    return this.createRequest({
      url: '/api/advertisements/last-queries',
      method: 'get',
      token,
    })()
  }

  deleteSavedQueries = (id) => {
    return this.createRequest({
      url: `/api/advertisements/saved-queries/${id}`,
      method: 'DELETE',
    })()
  }

  deleteAllQueries = () => {
    return this.createRequest({
      url: '/api/advertisements/queries',
      method: 'DELETE',
    })()
  }

  deleteQuery = (id) => {
    return this.createRequest({
      url: `/api/advertisements/query/${id}`,
      method: 'DELETE',
    })()
  }

  getBlackList = (query, categories) => {
    return this.createRequest({
      url: `/api/advertisements/blacklist`,
      method: 'get',
      params: {
        query,
        categories,
      },
      paramsSerializer: (params) => {
        return getQueryUrlFromData(params)
      },
    })()
  }

  updateBlackList = (id, payload) => {
    return this.createRequest({
      url: `api/advertisements/blacklist/${id}`,
      method: 'put',
      data: payload,
    })()
  }

  deleteBlackList = (id) => {
    return this.createRequest({
      url: `/api/advertisements/blacklist/${id}`,
      method: 'DELETE',
    })()
  }
  getFavoriteGroup = (id, token) => {
    return this.createRequest({
      url: `api/advertisements/favourite-groups/${id}`,
      method: 'get',
      token,
    })()
  }

  sharePublicGroup = (id) => {
    return this.createRequest({
      url: `/api/advertisements/favourite-groups/${id}/share`,
      method: 'put',
    })()
  }

  unsharePublicGroup = (id) => {
    return this.createRequest({
      url: `/advertisements/favourite-groups/${id}/unshare`,
      method: 'put',
    })()
  }

  getShareGroup = (id, token) => {
    return this.createRequest({
      url: `/api/advertisements/favourite-groups/shared/${id}`,
      method: 'get',
      ...(token && { token }),
    })()
  }

  getShareGroupCreatives = (id, params) => {
    return this.createRequest({
      url: `api/public/advertisements/favourite-groups/shared/${id}/adverts`,
      method: 'get',
      params,
      paramsSerializer: (params) => {
        return getQueryUrlFromData(params)
      },
    })()
  }

  getFavouriteGroups = (params) => {
    return this.createRequest({
      url: '/api/advertisements/favourite-groups',
      method: 'get',
      params,
      paramsSerializer: (params) => {
        return getQueryUrlFromData(params)
      },
    })()
  }

  deleteFavoriteCreativesFromGroups = (data) => {
    return this.createRequest({
      url: '/api/advertisements/favourite',
      method: 'DELETE',
      data,
    })()
  }

  deleteFavoritesGroup = (data) => {
    return this.createRequest({
      url: '/api/advertisements/favourite-groups',
      method: 'DELETE',
      data,
    })()
  }

  updateFavoritesGroup = (id, name) => {
    return this.createRequest({
      url: `/api/advertisements/favourite-groups/${id}`,
      method: 'put',
      data: {
        name,
      },
    })()
  }

  translateText = (did, locale, mode) => {
    return this.createRequest({
      url: `/api/public/advertisements/${did}/translate-text`,
      method: 'post',
      data: {
        mode,
        locale,
      },
    })()
  }

  getUniqueUserImageLimit = (token) => {
    return this.createRequest({
      url: '/api/advertisements/unique-user-image/limit',
      method: 'get',
      ...(token && { token }),
    })()
  }

  getSearchHints = this.createRequest({
    url: `/api/advertisements/search-hints`,
    method: 'get',
  })
}
